import React from 'react';
import {ThemeProvider, withStyles} from '@material-ui/core/styles';
import { BrowserRouter as Router,Route, Switch, Redirect } from 'react-router-dom';
import axios from 'axios';
import {connect, setStore} from 'trim-redux'
import {defaultVariabls, generateURLs} from './config';
import Login from "./class/pages/Authentication/Login";
import Loader from "./class/components/elements/Loader";
import {RTL, theme} from './config/design/theme';
import {Styles} from "./config/design/styles";
import {SnackbarProvider} from "notistack";
import PrivateRoute from "./class/components/elements/PrivateRoute";
import Layout from "./class/components/layouts/layout";
import Error404 from './class/pages/errors/404';
import FileManagerPage from "./class/pages/fileManager/FileManagerPage";
import MobileVerify from "./class/pages/Authentication/MobileVerify";
import ChangePassword from "./class/pages/user/ChangePassword";
import ForgetPassword from "./class/pages/Authentication/ForgetPassword";
import LoginWithToken from "./class/pages/Authentication/LoginWithToken";
import Register from "./class/pages/Authentication/Register";
import VerifyEmailPage from "./class/pages/Authentication/VerifyEmailPage";
import Permission from "./class/components/elements/Permission";
import {ErrorBoundary} from 'react-error-boundary'
import IconButton from "@material-ui/core/IconButton/IconButton";
import CachedRoundedIcon from '@material-ui/icons/CachedRounded';
import Snackbar from "@material-ui/core/Snackbar/Snackbar";
import {Translate} from "./config/Translate";
import MakeContent from "./class/pages/contents/MakeContent";
import UserDetails from "./class/pages/user/UserDetails";
import MakeShopPage from "./class/pages/shop/MakeShopPage";
import ShopsPage from "./class/pages/shop/ShopsPage";
import MakeProduct from "./class/pages/products/MakeProduct";
import CategoriesPage from "./class/pages/admin/categories/CategoriesPage";
import MakeCategory from "./class/pages/admin/categories/MakeCategory";
import ProductsPage from "./class/pages/products/ProductsPage";
import CommentsPage from "./class/pages/admin/comments/CommentsPage";
import ManageAbout from "./class/pages/admin/pages/ManageAbout";
import ManageTerms from "./class/pages/admin/pages/ManageTerms";
import UsersPage from "./class/pages/admin/users/UsersPage";
import ActivityLog from "./class/pages/admin/users/UsersLogPage";
import AddUserPage from "./class/pages/admin/users/AddUserPage";
import WalletPage from "./class/pages/wallet/WalletPage";
import Verification from "./class/pages/user/components/Verification";
import WalletsPage from "./class/pages/admin/wallets/WalletsPage";
import WalletHistoryPage from "./class/pages/admin/wallets/WalletHistoryPage";
import ManageVerificationsPage from "./class/pages/admin/users/ManageVerificationsPage";
import ManageOrdersPage from "./class/pages/admin/orders/ManageOrdersPage";
import MakeVariable from "./class/pages/admin/variables/MakeVariable";
import VariablesPage from "./class/pages/admin/variables/VariablesPage";
import ManageUserPage from "./class/pages/admin/users/ManageUserPage";
import MyAddressesPage from "./class/pages/user/address/MyAddressesPage";
import AttributesPage from "./class/pages/admin/attributes/AttributesPage";
import MakeValues from "./class/pages/admin/attributes/MakeValues";
import PricingPage from "./class/pages/pricing/PricingPage";
import MakePricing from "./class/pages/pricing/MakePricing";
import ModifyPricingPage from "./class/pages/pricing/ModifyPricingPage";
import BrandsPage from "./class/pages/admin/brands/BrandsPage";
import MakeBrand from "./class/pages/admin/brands/MakeBrand";
import ManagePrivacyPolicy from "./class/pages/admin/pages/ManagePrivacyPolicy";
import ManageSellerTerms from "./class/pages/admin/pages/ManageSellerTerms";
import Wishlist from "./class/pages/user/wishlist/Wishlist";
import SlideShowsPage from "./class/pages/admin/settings/slideshows/SlideShowsPage";
import BannersPage from "./class/pages/admin/settings/banners/BannersPage";
import DiscountsPage from "./class/pages/admin/discounts/DiscountsPage";
import MakeDiscount from "./class/pages/admin/discounts/MakeDiscount";
import CheckoutPage from "./class/pages/checkout/CheckoutPage";
import CreateOrder from "./class/pages/checkout/CreateOrder";
import SiteSettingsPage from "./class/pages/admin/settings/siteSettings/SiteSettingsPage";
import UserOrdersPage from "./class/pages/orders/user_orders/UserOrdersPage";
import ViewOrder from "./class/pages/orders/user_orders/ViewOrder";
import ManageOrder from "./class/pages/admin/orders/ManageOrder";
import Role from "./class/components/elements/Role";
import ShopOrdersPage from "./class/pages/orders/shop_orders/ShopOrdersPage";
import CheckOrder from "./class/pages/orders/shop_orders/CheckOrder";
import SyncAuth from "./class/pages/Authentication/SyncAuth";
import ShopCommentsPage from "./class/pages/admin/shop-comments/ShopCommentsPage";
import AdminDashboard from "./class/pages/admin/analytics/AdminDashboard";
import SellerDashboard from "./class/pages/Dashboard/SellerDashboard";
import OrdersAnalyticsPage from "./class/pages/admin/analytics/OrdersAnalyticsPage";
import ManageContact from "./class/pages/admin/pages/ManagePage";
import UserDashboard from "./class/pages/Dashboard/UserDashboard";
import RedirectsPage from "./class/pages/admin/settings/redirects/RedirectsPage";
import ManageViolations from "./class/pages/admin/pages/ManageViolations";
import TicketsPage from "./class/pages/tickets/TicketsPage";
import Ticket from "./class/pages/tickets/Ticket/index";
import DepartmentsPage from "./class/pages/tickets/departments/DepartmentsPage";
import AgentsPage from "./class/pages/admin/users/agents/AgentsPage";
import ManageAgentPage from "./class/pages/admin/users/agents/ManageAgentPage";
import AgentDashboard from "./class/pages/Dashboard/AgentDashboard";
import AgentOrdersPage from "./class/pages/admin/users/agents/AgentOrdersPage";
import TransferPricingPage from "./class/pages/admin/settings/transfer_pricing/TransferPricingPage";
import ManageAgentTerms from "./class/pages/admin/pages/ManageAgentTerms";
import Feature from "./class/components/elements/Feature";
import ContentsPage from "./class/pages/contents/ContentsPage";
import BlogCategoriesPage from "./class/pages/admin/blog_categories/BlogCategoriesPage";
import MakeBlogCategory from "./class/pages/admin/blog_categories/MakeBlogCategory";
import BlogCommentsPage from "./class/pages/admin/blog-comments/BlogCommentsPage";
import MakePage from "./class/pages/admin/pages/MakePage";
import PagesPage from "./class/pages/admin/pages/PagesPage";
import ManageTemplateWithoutDrag from "./class/pages/admin/template/ManageTemplateWithoutDrag";
import SiteInformationPage from "./class/pages/admin/settings/siteSettings/SiteInformationPage";
import ContactInformationPage from "./class/pages/admin/settings/siteSettings/contact/ContactInformationPage";
import CustomCode from "./class/pages/admin/settings/siteSettings/CustomCode";
import HeaderAndFooter from "./class/pages/admin/template/HeaderAndFooter";
import AbilitiesPage from "./class/pages/admin/abilities/AbilitiesPage";
import MakeAbility from "./class/pages/admin/abilities/MakeAbility";
import PeoplePage from "./class/pages/admin/people/PeoplePage";
import AddPersonPage from "./class/pages/admin/people/AddPersonPage";
import EditPersonPage from "./class/pages/admin/people/EditPersonPage";
import SubmitReview from "./class/pages/Front/SubmitReview";
import SubmitDetails from "./class/pages/Front/SubmitDetails";
import VisitorsPage from "./class/pages/admin/visitors/VisitorsPage";
import VisitsPage from "./class/pages/admin/visits/VisitsPage";

class App extends React.Component{
    state ={
        loading:true,
    };
    async componentDidMount(){
        let external_redirect = localStorage.getItem('external_redirect');
        if(!!external_redirect){
            localStorage.removeItem('external_redirect');
            window.location.replace(external_redirect);
        }
        await this.loadData();

        if(this.props.isAuth){
            await this.loadUserSetting();
        }else{
            await this.loadSetting();
        }
    }
    async loadSetting(){
        let config = {
            headers: {
                Accept: 'application/json',
            }
        };
        await axios.get(`${defaultVariabls.url}/settings/get_all`, config)
            .then(response => {
                setStore({
                    setting:response.data,
                    primary_color:response.data.primary_color,
                    secondary_color:response.data.secondary_color,
                    logo:response.data.site_logo,
                    app_name:response.data.app_name,
                    about:response.data.about,
                    features:response.data.features,
                });
                this.setState({
                    loading:false,
                })
            }).catch(error => {
                console.log(error.response)
            })
    }
    async loadUserSetting(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`

            }
        };
        await axios.get(`${defaultVariabls.url}/settings/get_all`, config)
            .then(response => {
                setStore({
                    setting:response.data,
                    primary_color:response.data.primary_color,
                    secondary_color:response.data.secondary_color,
                    logo:response.data.site_logo,
                    app_name:response.data.app_name,
                    about:response.data.about,
                    features:response.data.features,
                });
                this.setState({
                    loading:false,
                })
            }).catch(error => {
                console.log(error.response)
            })
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/checkLogin`, config)
                .then(response => {
                    setStore({
                        isAuth : true,
                        user : response.data,
                    });
                }).catch(error => {
                    console.log(error.response)
                    setStore({
                        isAuth : false,
                        user : null,
                    });
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }

    ErrorFallback({error}) {
        if(!!error){
            return (
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    open={true}
                    message={Translate.errorHappens}
                    action={
                        <React.Fragment>
                            <IconButton  onClick={() => window.location.reload()}>
                                <CachedRoundedIcon color="secondary"/>
                            </IconButton>
                        </React.Fragment>
                    }
                />
            )
        }

    }
    classes = this.props.classes;
    render(){
        let {user,global_loading} = this.props;
        if(this.state.loading){
            return(
                <Loader/>
            )
        }else{
            return(
                <ThemeProvider theme={theme}>
                    <SnackbarProvider anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}>
                        <RTL>
                            <ErrorBoundary FallbackComponent={this.ErrorFallback}>
                                <Router>
                                    <Switch>
                                        <Redirect exact from='/' to='/dashboard'/>
                                        <Route  path="/notingFound" >
                                            <Error404/>
                                        </Route>
                                        {/*Auth Routes*/}
                                        <Route path="/login">
                                            <Login />
                                        </Route>
                                        <Route path="/sync-auth">
                                            <SyncAuth />
                                        </Route>
                                        <Route exact path="/register">
                                            <Register />
                                        </Route>
                                        <Route exact path="/verifyEmail/:id/:code">
                                            <VerifyEmailPage />
                                        </Route>
                                        <Route path="/token-login">
                                            <LoginWithToken />
                                        </Route>
                                        <Route path="/forget">
                                            <ForgetPassword />
                                        </Route>

                                        <PrivateRoute path="/verify-mobile">
                                            <MobileVerify />
                                        </PrivateRoute>
                                        <Route path="/rev/:id">
                                            <SubmitReview />
                                        </Route>
                                        <Route path="/det/:id">
                                            <SubmitDetails />
                                        </Route>
                                        <Layout>
                                            <PrivateRoute exact path="/dashboard">
                                                {
                                                    !!user ? user.role.type === 'admin' ? <AdminDashboard/> : user.role.name === 'user' ? <UserDashboard/> : user.role.name === 'agent' ? <AgentDashboard/> : <SellerDashboard/> : null
                                                }
                                            </PrivateRoute>
                                            <Permission rule="manageSettings">
                                                <PrivateRoute exact path="/manage/abilities">
                                                    <AbilitiesPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/edit/ability/:id">
                                                    <MakeAbility />
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/create/ability">
                                                    <MakeAbility new/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/visitors">
                                                    <VisitorsPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/visits">
                                                    <VisitsPage/>
                                                </PrivateRoute>
                                            </Permission>
                                            <Feature check="tickets">
                                                <PrivateRoute path="/tickets">
                                                    <TicketsPage />
                                                </PrivateRoute>
                                                <PrivateRoute path="/ticket/:id">
                                                    <Ticket/>
                                                </PrivateRoute>
                                                <Permission rule="manageSettings">
                                                    <PrivateRoute path="/manage/departments">
                                                        <DepartmentsPage />
                                                    </PrivateRoute>
                                                    <PrivateRoute path="/manage/tickets">
                                                        <TicketsPage manage />
                                                    </PrivateRoute>
                                                    <PrivateRoute path="/manage/ticket/:id">
                                                        <Ticket manage/>
                                                    </PrivateRoute>
                                                </Permission>
                                            </Feature>
                                            <Permission rule="fileManagerPage">
                                                <PrivateRoute path="/file-manager">
                                                    <FileManagerPage/>
                                                </PrivateRoute>
                                            </Permission>
                                            <PrivateRoute path="/account/password">
                                                <ChangePassword/>
                                            </PrivateRoute>
                                            <Feature check="wishlist">
                                                <PrivateRoute path="/wishlist">
                                                    <Wishlist/>
                                                </PrivateRoute>
                                            </Feature>
                                            <PrivateRoute path="/account/details">
                                                <UserDetails/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/account/address">
                                                <MyAddressesPage/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/account/verification">
                                                <Verification/>
                                            </PrivateRoute>
                                            <Feature check="wallet">
                                                <PrivateRoute exact path="/wallet/view">
                                                    <WalletPage/>
                                                </PrivateRoute>
                                            </Feature>
                                            <PrivateRoute exact path="/checkout">
                                                <CheckoutPage/>
                                            </PrivateRoute>
                                            <PrivateRoute exact path="/order">
                                                <CreateOrder/>
                                            </PrivateRoute>
                                            <Permission rule="manageSettings">
                                                <PrivateRoute exact path="/manage/comments">
                                                    <CommentsPage/>
                                                </PrivateRoute>
                                                <Feature check="review_for_shop">
                                                    <PrivateRoute exact path="/manage/shop-comments">
                                                        <ShopCommentsPage/>
                                                    </PrivateRoute>
                                                </Feature>
                                                <PrivateRoute exact path="/manage/pages/about">
                                                    <ManageAbout/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/contacts">
                                                    <ManageContact/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/violations">
                                                    <ManageViolations/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/pages/terms">
                                                    <ManageTerms/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/pages/privacy-policy">
                                                    <ManagePrivacyPolicy/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/pages/seller-terms">
                                                    <ManageSellerTerms/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/pages/agent-terms">
                                                    <ManageAgentTerms/>
                                                </PrivateRoute>
                                                <PrivateRoute path="/setting/contact">
                                                    <ContactInformationPage/>
                                                </PrivateRoute>
                                                <PrivateRoute path="/setting/custom-code">
                                                    <CustomCode />
                                                </PrivateRoute>
                                                <PrivateRoute path="/setting/header-footer">
                                                    <HeaderAndFooter />
                                                </PrivateRoute>
                                                <PrivateRoute path="/setting/information">
                                                    <SiteInformationPage/>
                                                </PrivateRoute>
                                                {/*<PrivateRoute exact path="/settings/translate-front">
                                                    <TranslateFront/>
                                                </PrivateRoute>*/}
                                                <PrivateRoute exact path="/settings/slideshows">
                                                    <SlideShowsPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/settings/banners">
                                                    <BannersPage/>
                                                </PrivateRoute>
                                                <Feature check="redirects">
                                                <PrivateRoute exact path="/settings/redirects">
                                                    <RedirectsPage/>
                                                </PrivateRoute>
                                                </Feature>
                                                <PrivateRoute exact path="/settings/transfer-pricing">
                                                    <TransferPricingPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/template">
                                                    <ManageTemplateWithoutDrag/>
                                                </PrivateRoute>
                                                <Feature check="agent">
                                                <PrivateRoute exact path="/manage/agents">
                                                    <AgentsPage/>
                                                </PrivateRoute>
                                                </Feature>
                                                <PrivateRoute exact path="/manage/users/view/:role?">
                                                    <UsersPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/people/view/:status?">
                                                    <PeoplePage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/people/add">
                                                    <AddPersonPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/person/:id">
                                                    <EditPersonPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/users/add">
                                                    <AddUserPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/user/:id">
                                                    <ManageUserPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/agent/:id">
                                                    <ManageAgentPage/>
                                                </PrivateRoute>
                                                <Feature check="activity_log">
                                                    <PrivateRoute exact path="/manage/activities/:query?">
                                                        <ActivityLog/>
                                                    </PrivateRoute>
                                                </Feature>
                                                <PrivateRoute exact path="/analytics/orders">
                                                    <OrdersAnalyticsPage/>
                                                </PrivateRoute>
                                            </Permission>
                                            <Permission rule="manageShops">
                                                <Feature check="marketplace">
                                                    <PrivateRoute exact path="/manage/shops">
                                                        <ShopsPage/>
                                                    </PrivateRoute>
                                                </Feature>
                                                <PrivateRoute exact path="/manage/products">
                                                    <ProductsPage manage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/orders">
                                                    <ManageOrdersPage manage/>
                                                </PrivateRoute>
                                                <PrivateRoute path="/order/manage/:id">
                                                    <ManageOrder/>
                                                </PrivateRoute>
                                                <PrivateRoute path="/manage/pricing/:type" exact>
                                                    <ModifyPricingPage manage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/categories">
                                                    <CategoriesPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/create/category">
                                                    <MakeCategory new/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/edit/category/:id">
                                                    <MakeCategory />
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/pages">
                                                    <PagesPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/create/page">
                                                    <MakePage new/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/edit/page/:id">
                                                    <MakePage  />
                                                </PrivateRoute>

                                                <Feature check="brands">
                                                    <PrivateRoute exact path="/manage/brands">
                                                        <BrandsPage/>
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/edit/brand/:id">
                                                        <MakeBrand />
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/create/brand">
                                                        <MakeBrand new/>
                                                    </PrivateRoute>
                                                </Feature>
                                                <PrivateRoute exact path="/manage/variables">
                                                    <VariablesPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/create/variable">
                                                    <MakeVariable new/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/edit/variable/:id">
                                                    <MakeVariable />
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/attributes">
                                                    <AttributesPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/attribute/:id">
                                                    <MakeValues/>
                                                </PrivateRoute>
                                            </Permission>
                                            <Permission rule="manageOrders">
                                                <PrivateRoute exact path="/manage/discounts">
                                                    <DiscountsPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/create/discount">
                                                    <MakeDiscount new/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/edit/discount/:id">
                                                    <MakeDiscount />
                                                </PrivateRoute>
                                            </Permission>
                                            <Permission rule="managePayments">
                                                <Feature check="wallet">
                                                    <PrivateRoute exact path="/manage/wallets">
                                                        <WalletsPage/>
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/manage/wallet/:id">
                                                        <WalletHistoryPage/>
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/manage/verifications">
                                                        <ManageVerificationsPage/>
                                                    </PrivateRoute>
                                                </Feature>
                                            </Permission>
                                            <PrivateRoute path="/create/shop">
                                                <MakeShopPage/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/edit/shop/:id">
                                                <MakeShopPage edit/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/my-shops">
                                                <ShopsPage myShops/>
                                            </PrivateRoute>
                                            <Feature check="blog">
                                                <PrivateRoute exact path="/manage/blog-categories">
                                                    <BlogCategoriesPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/blog-comments">
                                                    <BlogCommentsPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/create/blog-category">
                                                    <MakeBlogCategory new/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/edit/blog-category/:id">
                                                    <MakeBlogCategory />
                                                </PrivateRoute>
                                                <PrivateRoute path="/manage/contents" exact>
                                                    <ContentsPage/>
                                                </PrivateRoute>
                                                <PrivateRoute path="/create/content" exact>
                                                    <MakeContent new/>
                                                </PrivateRoute>
                                                <PrivateRoute path="/edit/content/:id">
                                                    <MakeContent />
                                                </PrivateRoute>
                                            </Feature>
                                            <PrivateRoute path="/pricing" exact>
                                                <PricingPage/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/modify-pricing" exact>
                                                <ModifyPricingPage/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/pricing/product/:id" exact>
                                                <MakePricing/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/my-products" exact>
                                                <ProductsPage/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/create/product" exact>
                                                <MakeProduct new/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/edit/product/:id">
                                                <MakeProduct />
                                            </PrivateRoute>
                                            <PrivateRoute path="/my-orders">
                                                <UserOrdersPage />
                                            </PrivateRoute>
                                            <Feature check="agent">
                                                <PrivateRoute path="/agent">
                                                    <AgentOrdersPage />
                                                </PrivateRoute>
                                            </Feature>
                                            <PrivateRoute path="/order/view/:id">
                                                <ViewOrder/>
                                            </PrivateRoute>
                                            <Feature check="marketplace">
                                                <Role role="supplier" type="normal">
                                                    <PrivateRoute path="/shop-orders">
                                                        <ShopOrdersPage />
                                                    </PrivateRoute>
                                                    <PrivateRoute path="/order/check/:id">
                                                        <CheckOrder/>
                                                    </PrivateRoute>
                                                </Role>
                                            </Feature>
                                            <Route  path="/404" >
                                                <Error404/>
                                            </Route>
                                        </Layout>
                                        {/*Errors Routes*/}
                                        <Route path="*" component={Error404} status={404}/>
                                    </Switch>
                                </Router>
                            </ErrorBoundary>
                        </RTL>
                    </SnackbarProvider>
                </ThemeProvider>
            )
        }

    }

}
const mstp = state => ({
    user: state.user,
    isAuth:state.isAuth,
    global_loading:state.global_loading
});
export default withStyles(Styles)(connect(mstp)(App));
